(function () {
    document.querySelectorAll('.lgnd-filter-group-header').forEach(function (btn) {
        btn.addEventListener('click', function () {
            var group = btn.closest('.lgnd-filter-group');
            if (group) {
                group.classList.toggle('open');
            }
        });
    });

    var mobileOpenBtn = document.getElementById('js-mobile-filter-open');
    var mobileCloseBtn = document.getElementById('js-mobile-filter-close');
    var sidebar = document.getElementById('js-collection-sidebar');

    function openSidebar(e) {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (sidebar) {
            sidebar.classList.add('active');
            document.body.style.overflow = 'hidden';
        }
    }

    function closeSidebar(e) {
        if (e) {
            e.preventDefault();
        }
        if (sidebar) {
            sidebar.classList.remove('active');
            document.body.style.overflow = '';
        }
    }

    if (mobileOpenBtn && sidebar) {
        mobileOpenBtn.addEventListener('click', openSidebar);
    }

    if (mobileCloseBtn && sidebar) {
        mobileCloseBtn.addEventListener('click', closeSidebar);
    }

    if (sidebar) {
        sidebar.addEventListener('click', function (e) {
            if (e.target === sidebar) {
                closeSidebar(e);
            }
        });
    }

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && sidebar && sidebar.classList.contains('active')) {
            closeSidebar(e);
        }
    });

    var sortSelect = document.getElementById('lgnd-sort-select');
    if (sortSelect) {
        sortSelect.addEventListener('change', function () {
            var url = new URL(window.location.href);
            url.searchParams.set('sort_by', sortSelect.value);
            window.location.href = url.toString();
        });
    }

    var grid = document.getElementById('js-collection-grid');
    var checkboxes = document.querySelectorAll('.lgnd-filter-group-content input[type="checkbox"]');
    var clearBtn = document.getElementById('js-clear-filters');
    var countCurrent = document.getElementById('js-count-current');

    function applyFilters() {
        var activeFilters = {
            model: [],
            country: [],
            category: [],
            price: [],
        };

        checkboxes.forEach(function (chk) {
            if (chk.checked) {
                var type = chk.getAttribute('data-filter-type');
                if (type === 'price') {
                    activeFilters.price.push({
                        min: parseInt(chk.getAttribute('data-min'), 10),
                        max: parseInt(chk.getAttribute('data-max'), 10),
                    });
                } else {
                    var rawVals = chk.getAttribute('data-val') || '';
                    var valList = rawVals.split(',').map(function (s) {
                        return s.trim().toLowerCase();
                    });
                    activeFilters[type] = activeFilters[type].concat(valList);
                }
            }
        });

        var hasActiveFilters =
            activeFilters.model.length > 0 ||
            activeFilters.country.length > 0 ||
            activeFilters.category.length > 0 ||
            activeFilters.price.length > 0;

        var cards = grid.querySelectorAll('.showcase-card');
        var visibleCount = 0;

        cards.forEach(function (card) {
            if (!hasActiveFilters) {
                card.style.display = '';
                visibleCount++;
                return;
            }

            var cardText =
                (card.innerText || '').toLowerCase() + ' ' + (card.getAttribute('aria-label') || '').toLowerCase();

            var matchModel =
                activeFilters.model.length === 0 ||
                activeFilters.model.some(function (term) {
                    return cardText.indexOf(term) !== -1;
                });

            var matchCountry =
                activeFilters.country.length === 0 ||
                activeFilters.country.some(function (term) {
                    return cardText.indexOf(term) !== -1;
                });

            var matchCategory =
                activeFilters.category.length === 0 ||
                activeFilters.category.some(function (term) {
                    return cardText.indexOf(term) !== -1;
                });

            var matchPrice = true;
            if (activeFilters.price.length > 0) {
                var priceEl = card.querySelector('.showcase-price');
                var priceVal = 0;
                if (priceEl) {
                    var numericString = priceEl.innerText.replace(/[^0-9]/g, '');
                    priceVal = parseInt(numericString, 10) || 0;
                }
                matchPrice = activeFilters.price.some(function (range) {
                    return priceVal >= range.min && priceVal <= range.max;
                });
            }

            if (matchModel && matchCountry && matchCategory && matchPrice) {
                card.style.display = '';
                visibleCount++;
            } else {
                card.style.display = 'none';
            }
        });

        if (countCurrent) {
            countCurrent.innerText = visibleCount;
        }
    }

    checkboxes.forEach(function (chk) {
        chk.addEventListener('change', applyFilters);
    });

    if (clearBtn) {
        clearBtn.addEventListener('click', function () {
            checkboxes.forEach(function (chk) {
                chk.checked = false;
            });
            applyFilters();
        });
    }

    var sentinel = document.getElementById('js-infinite-sentinel');
    var loader = document.getElementById('js-infinite-loader');
    var scrollContainer = document.getElementById('js-infinite-scroll-container');
    var isLoading = false;

    function initInfiniteScroll() {
        if (!sentinel || !('IntersectionObserver' in window)) return;

        var observer = new IntersectionObserver(
            function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting && !isLoading) {
                        loadNextPage();
                    }
                });
            },
            {
                rootMargin: '400px 0px 400px 0px',
            }
        );

        observer.observe(sentinel);

        function loadNextPage() {
            var nextUrl = sentinel.getAttribute('data-next-url');
            if (!nextUrl) {
                observer.disconnect();
                return;
            }

            if (window.location.search.indexOf('preview_theme_id') !== -1) {
                try {
                    var currentParams = new URLSearchParams(window.location.search);
                    var prevId = currentParams.get('preview_theme_id');
                    if (prevId) {
                        var parsedUrl = new URL(nextUrl, window.location.origin);
                        parsedUrl.searchParams.set('preview_theme_id', prevId);
                        nextUrl = parsedUrl.toString();
                    }
                } catch (e) {}
            }

            isLoading = true;
            if (loader) loader.classList.add('active');

            fetch(nextUrl)
                .then(function (res) {
                    return res.text();
                })
                .then(function (htmlText) {
                    var parser = new DOMParser();
                    var doc = parser.parseFromString(htmlText, 'text/html');

                    var newCards = doc.querySelectorAll('#js-collection-grid .showcase-card');
                    if (newCards.length > 0 && grid) {
                        newCards.forEach(function (card) {
                            grid.appendChild(card);
                        });

                        applyFilters();

                        if (window.LegendariosWishlist) {
                            window.LegendariosWishlist.syncUI(grid);
                        }
                    }

                    var newSentinel = doc.getElementById('js-infinite-sentinel');
                    if (newSentinel && newSentinel.getAttribute('data-next-url')) {
                        var updatedNextUrl = newSentinel.getAttribute('data-next-url');
                        sentinel.setAttribute('data-next-url', updatedNextUrl);
                    } else {
                        sentinel.removeAttribute('data-next-url');
                        sentinel.remove();
                        observer.disconnect();

                        if (scrollContainer) {
                            var endEl = doc.getElementById('js-infinite-end');
                            if (endEl) {
                                scrollContainer.appendChild(endEl);
                            }
                        }
                    }
                })
                .catch(function (err) {
                    console.error('Erro ao carregar mais produtos:', err);
                })
                .finally(function () {
                    isLoading = false;
                    if (loader) loader.classList.remove('active');
                });
        }
    }

    initInfiniteScroll();
})();